"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("homeInfoIntra", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {},
    template: require("./homeInfoIntra.html"),
    controller: function controller($scope, $http, $translate) {
      $http.get('/rest/home/resume-client').then(function (response) {
        $scope.resume = response.data;
        $scope.crm = $scope.resume.suivi;
      });
      $scope.loadUtilisateursConnectes = function () {
        $scope.loadingUtilisateursConnectes = true;
        $http.get('/rest/home/resume-utilisateurs').then(function (response) {
          $scope.utilisateurs = response.data;
        }).finally(function () {
          $scope.loadingUtilisateursConnectes = false;
        });
      };
      $scope.loadUtilisateursConnectes();
      $scope.invitationsTableConfig = {
        id: 'invitationsTable',
        source: "resume.invitations",
        height: 600,
        columns: [{
          attribute: 'nom',
          title: "Nom",
          cellClass: "align-l",
          sortable: true
        }, {
          attribute: 'prenom',
          title: "Prenom",
          cellClass: "align-l",
          sortable: true
        }, {
          attribute: 'fonction',
          id: 'fonction',
          title: "Fonction",
          cellClass: "align-l",
          sortable: true
        }, {
          id: 'nbConnexion',
          attribute: 'nbConnexion',
          title: "Nb connexion",
          cellClass: "align-l",
          sortable: true,
          sortType: 'number'
        }, {
          title: "Suivi",
          columns: [{
            title: 'Invitation',
            attribute: 'envoye',
            template: '<span ng-if="model.envoye">Envoyée</span> <span  ng-if="!model.envoye" class="blue">A envoyer</span>'
          }, {
            title: "Echec",
            attribute: "echecEnvoi",
            template: '<i ng-if="model.echecEnvoi" class="fa fa-check green"></i>',
            cellClass: "align-c",
            sortable: true,
            sortType: 'boolean'
          }, {
            title: "Relancer",
            attribute: "aRelancer",
            template: '<i ng-if="model.aRelancer" class="fa fa-check green"></i>',
            cellClass: "align-c",
            sortable: true,
            sortType: 'boolean'
          }, {
            attribute: 'reponse',
            title: "Réponse",
            cellClass: "align-c",
            sortable: true
          }, {
            attribute: 'reponseParFormulaire',
            id: 'reponseParFormulaire',
            title: "Form.",
            cellClass: "align-c",
            sortable: true,
            template: '<span ng-if="model.reponseParFormulaire"><i class="fa fa-check green"></i></span>',
            sortType: 'boolean'
          }, {
            attribute: 'session',
            title: "Session",
            cellClass: "align-c",
            sortable: true
          }, {
            attribute: 'journee',
            title: "Journée",
            cellClass: "align-c",
            sortable: true
          }, {
            attribute: 'presence',
            title: "Présence",
            cellClass: "align-c",
            sortable: true
          }, {
            attribute: 'commentaire',
            title: "Commentaire taelys",
            cellClass: "align-c",
            width: '250px',
            sortable: true
          }, {
            attribute: 'remarque',
            id: 'remarque',
            title: "Remarque formulaire",
            cellClass: "align-c",
            sortable: true
          }]
        }]
      };
      $scope.utilisateursTableConfig = {
        id: 'homeUtilisateursTable',
        source: "utilisateurs",
        height: 600,
        columns: [{
          attribute: 'denomination',
          title: "Utilisateur",
          tooltip: 'Utilisateurs connectés dans les 3 dernières heures',
          cellClass: "align-c",
          sortable: true
        }, {
          attribute: 'email',
          title: "Email",
          cellClass: "align-c",
          sortable: true
        }, {
          attribute: 'dernierAcces',
          title: "Dernier accès",
          filter: 'dureeFromMinutes',
          cellClass: "align-c",
          sortable: true,
          sortType: "number"
        }, {
          title: "Contexte",
          template: '<i class="fa fa-warning orange" ng-if="model.contexte.alerte" tl-tooltip="Un filtre est activé sans valeur cochée."></i>' + '<div ng-if="model.contexteResume.resumeBudget">Budget : {{model.contexteResume.resumeBudget}}</div>' + '<div ng-if="model.contexte.contexteDette.filtreSimulation.enabled">{{model.contexte.contexteDette.filtreSimulation.simulationsInclues.length}} simulation(s)' + '<div ng-if="model.contexte.contexteDette.filtreProduit.enabled">{{model.contexte.contexteDette.filtreProduit.produitsInclus.length}} produit(s)' + '</div>',
          cellClass: "align-c",
          sortable: true
        }, {
          attribute: 'dateVisualisation',
          title: "Date de visualisation",
          template: '{{model.dateVisualisation|dateShort}} ',
          cellClass: "align-c",
          sortable: true,
          sortType: 'date'
        }]
      };
      $scope.formationsTableConfig = {
        id: 'homeFormationsTable',
        source: "resume.formations",
        initialSort: ['date', 'desc'],
        columns: [{
          attribute: 'nom',
          title: 'Nom',
          cellClass: "align-c"
        }, {
          attribute: 'prenom',
          title: 'Prénom',
          cellClass: "align-c"
        }, {
          attribute: 'formation',
          title: 'Formation',
          cellClass: "align-c"
        }, {
          attribute: 'date',
          title: 'Date',
          template: '<span>{{model.date | dateShort}}</span><span ng-if="model.heure"> ({{model.heure}})</span>',
          filter: "dateShort",
          sortable: true,
          sortType: "date",
          width: "200px",
          cellClass: "align-c"
        }, {
          attribute: 'formationModalite',
          title: 'Modalité',
          template: "<span> {{'lov.formationModalites.' + model.formationModalite | translate}}</span>",
          width: "200px",
          cellClass: "align-c"
        }]
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/home/infoIntra/homeInfoIntra.js
// module id = 2790
// module chunks = 13